/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';

import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * Global Type Definition Imports
 */
import { CNEdEmployee } from '../../../../config/interfaces';

interface CNEdListSettingsProps {
  facilityId: string;
  userId: string;
}

const CNEdListSettingsTable: FC<CNEdListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isCNEdRounder,
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin
  } = useUserRolesRef();

  const { isCNEdEnabled } = useFeatures();

  const {
    data: cnedEmployeesData,
    // isError: isGetEmployeeSubjectConfigError,
    // isFetching: isGetEmployeeSubjectConfigFetching,
    isLoading: isGetEmployeeSubjectConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    { employeeId: userId, roundingType: 'cned' },
    {
      skip: !isCNEdEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: CNEdEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'cned',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={cnedEmployeesData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isCNEdRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isCNEdEnabled}
      loadingSupportList={isGetEmployeeSubjectConfigLoading}
      type="cned"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(CNEdListSettingsTable);
